export default "__VITE_ASSET__B4eh9p9l__"